import React from 'react';
import './Sections.scss';
// import LogoTooltip from '../LogoTooltip/LogoTooltip';
// import { gsap } from 'gsap';
import logo from '../../assets/awsIntelLogo.svg';

function Hero() {
  return (
    <section className="hero">
      <div className="hero__logoCont">
        <img src={logo} alt="aws intel logo" />
      </div>
      <div className="hero__textCont">
        <h1>Cloud Innovation</h1>
        <h2>for Virtually Every Application</h2>

        <p>
          Explore how customers are using the AWS cloud with Intel technologies to power a broad
          range of applications to help optimize food supply chains, transform capital markets,
          discover soccer talent around the world, change the face of moviemaking, and save
          endangered species.
        </p>
      </div>
      <div className="hero__linksHeaderCont">
        <div className="line" />
        <p>experience our content</p>
        <div className="line" />
      </div>
      <div className="hero__linksCont">
        <div className="row">
          <a href="#aiscout">Discovering Diverse Talent with AiScout</a>
          <a href="#reinventingInfra">Improving the Human Experience with Technology</a>
          <a href="#peak">Fighting Hunger in the UK with AI</a>
        </div>
        <div className="row">
          <a href="#comp3">Changing the Face of Moviemaking</a>
          <a href="#ronin">Helping Save Endangered Species</a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
